import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { jobLocationLabel } from '../../utils/jobLocation';
import Table from './Table';
import { useGetAllPendingJobsQuery } from '../../reactWrapper/Redux/apiSlice';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Pagination from '../Pagination/Pagination';

const PendingJobsTable = () => {
  const siblingCount = 1;
  const pageColumn = 1;
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const { data } = useGetAllPendingJobsQuery(page)

  const handlePageChange = useCallback(
    (page) => {
      setPage(page - 1);
    },
    [page]
  );

  const tableHeader = useMemo(
    () => [
      { title: 'Company', key: 'company' },
      { title: 'Role', key: 'stack' },
      { title: 'Date', key: 'date' },
      { title: 'Location', key: 'location' },
      { title: 'Matched', key: 'matched' },
      { title: '', key: 'actions' },
    ],
    []
  );

  const modifiedData = useMemo(() => {
    return data?.data?.map((each) => [
      <div className='flex gap-[18px] items-center'>
        <div className='w-11 h-11'>
          <img src={each?.companyLogo} alt='logo' />
        </div>
        <p>{each?.companyName}</p>
      </div>,
      each.stack,
      new Date(each?.postedDate).toLocaleDateString(),
      jobLocationLabel(each),
      <p className="font-semibold text-brand-navy">{each?.matched_count || 0}</p>,
      <div className="flex items-center gap-2">
        <Link
          className='text-sm inline-block rounded-lg border border-border py-[7.56px] px-[11.7px] text-muted-foreground'
          to={`/client-details/${each?.id}`}
        >
          Review
        </Link>
      </div>,
    ])
  }, [data])

  useEffect(() => {
    setTotalCount(data?.total ?? 0);
  }, [data]);

  return (
    <div>
      <Table header={tableHeader} label="" column={modifiedData} />
      <section className="w-full py-5">
        <Pagination
          rangeStart={
            totalCount !== 0
              ? (page || 0) * ((pageSize || 0) * pageColumn) + 1
              : 0
          }
          totalCount={totalCount}
          currentPage={(page || 0) + 1}
          pageSize={pageSize}
          pageColumn={pageColumn}
          siblingCount={siblingCount}
          onPageChange={handlePageChange}
          className="pt-9"
        />
      </section>
    </div>
  );
};

export default PendingJobsTable;
